import React from 'react';
import ReactDOM from 'react-dom/client';

// Global styles
import './index.css';
import './fonts.css';
import './details.css';

// Authentication
import Auth from './Helpers/auth';

// Providers
import { HelmetProvider } from 'react-helmet-async';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { PWAInstallProvider } from './Components/PWA/usePWAInstall';

// Application
import App from './App';

// Performance
import reportWebVitals from './reportWebVitals';

// PWA
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Check authentication on load
Auth.checkTokenOnLoad();

// React Query
const queryClient = new QueryClient();

// React root
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <PWAInstallProvider>
          <App />
        </PWAInstallProvider>
      </HelmetProvider>

      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </React.StrictMode>
);

// Performance monitoring
reportWebVitals();

// Register the YODA PWA service worker
serviceWorkerRegistration.register();
